<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap pb-5>
      <v-flex xs12>
        <v-layout justify-start wrap pb-4>
          <v-flex xs12 sm12 md12 lg12>
            <v-layout wrap>
              <v-flex xs6 sm10 md5 text-left>
                <v-layout wrap justify-start>
                  <v-flex xs2 sm2 md1 lg1>
                    <v-img width="30px" src="../../assets/images/arrow.svg">
                    </v-img
                  ></v-flex>
                  <v-flex>
                    <span
                      style="
                        font-family: nunitosansbold;
                        font-size: 20px;
                        color: #000000;
                      "
                      >Topper Video</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 sm6 md7 text-right>
                <v-dialog
                  :retain-focus="false"
                  v-model="dialog"
                  persistent
                  max-width="800px"
                  :key="dialog"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn outlined color="#9eaade" v-bind="attrs" v-on="on">
                      Add
                    </v-btn>
                  </template>
                  <v-card>
                    <v-form>
                      <v-card-title>
                        <span>Add Topper Video</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-layout justify-center wrap>
                            <v-flex xs12>
                              <v-text-field
                                outlined
                                dense
                                v-model="topper.title"
                                label=" Title of the Topper Video"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                outlined
                                dense
                                v-model="video"
                                label="Youtube Link of the Topper Video"
                              ></v-text-field> </v-flex
                            ><v-flex xs12>
                              <span> Description of the Video</span>
                              <div id="app">
                                <vue-editor
                                  v-model="topper.description"
                                ></vue-editor>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="dialog = false"
                        >
                          Close
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="add()">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout justify-start wrap v-if="list">
          <v-flex
            align-self-center
            xs12
            sm6
            md4
            lg4
            pa-2
            v-for="(item, i) in list"
            :key="i"
          >
            <v-layout justify-center wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-card elevation="0" rounded="lg" width="270px" height="200px">
                  <iframe
                    :key="item.video"
                    :src="
                      'https://www.youtube.com/embed/' + item.video + '?rel=0'
                    "
                    width="270px"
                    height="200px"
                    scrolling="no"
                    contain
                    frameborder="0"
                    allowtransparency="true"
                    allowfullscreen="true"
                  ></iframe>
                </v-card>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-layout justify-center wrap>
                <v-flex xs10 sm9 md11 lg9 xl5>
                  <router-link
                    style="text-decoration: none"
                    :to="'/topperVideoDetails/' + item._id"
                  >
                    <span
                      style="
                        font-family: nunitosanssemibold;
                        font-size: 14px;
                        color: #000000;
                      "
                      >{{ item.title }}</span
                    >
                  </router-link>
                </v-flex>
                <v-flex xs2 sm3 md1 lg3 xl7>
                  <v-dialog v-model="item.delete" max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-on="on"
                        v-bind="attrs"
                        right
                        overlap
                        offset-x="5"
                        >mdi-delete</v-icon
                      >
                    </template>
                    <v-card>
                      <v-card-title style="font-family: nunitosansregular">
                        Are you sure you want to delete this Video?
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="item.delete = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="appdelete(item)"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
              <span
                style="
                  font-family: nunitosansregular;
                  font-size: 10px;
                  color: #717171;
                "
                >{{ item.views }}</span
              >
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout justify-center wrap v-else>
          <v-flex xs12>
            <span
              style="
                font-family: nunitosansregular;
                color: #000000;
                font-size: 14px;
              "
              >Oops !! No data found..</span
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      hover: false,
      dialog: false,
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 5000,
      msg: "",
      list: [],
      video:"",
      topper: {
        title: null,
        // video: null,
        description: null,
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    cutVideo(eve) {
      let b = "https://www.youtube.com/embed/";
      var em = eve.replace("https://www.youtube.com/watch?v=", b);
      em = eve.replace("https://youtu.be/", b);
      this.splitUrl = em;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/toppervideo/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.list = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    add() {
      this.topper["video"]=this.video.match(/(^|=|\/)([0-9A-Za-z_-]{11})(\/|&|$|\?|#)/)[2]
      axios({
        method: "post",
        url: "/toppervideo/add",
        data: this.topper,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.dialog = false;
            Object.keys(this.topper).forEach(
              (key) => (this.topper[key] = null)
            );
            this.video=null,
            this.msg = " Added Successully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    appdelete(item) {
      axios({
        method: "POST",
        url: "/toppervideo/remove",
        data: {
          id: item._id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status == true) {
          this.msg = "Video Deleted";
          this.getData();
          this.showsnackbar = true;
        }
      });
    },
  },
};
</script>